import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "fixed z-[10000] inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
}
const _hoisted_2 = { class: "w-full flex flex-col items-center space-y-4 sm:items-end" }

import { computed } from "vue"
import GgmsToast from "@/components/GgmsToast.vue"
import { ToastService } from "@/shared/services/toast"


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsToasts',
  setup(__props) {

const toastService = new ToastService()

const toasts = computed(() => {
    return toastService.getToasts()
})

function closeToast(index: number) {
    toastService.removeToast(index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast, index) => {
        return (_openBlock(), _createBlock(_Transition, {
          key: index,
          "enter-active-class": "transform ease-out duration-300 transition",
          "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(GgmsToast, {
              toast: toast,
              onClickClose: ($event: any) => (closeToast(index))
            }, null, 8, ["toast", "onClickClose"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}
}

})